import { connect } from 'react-redux';
import { formatPostLists } from '~/queue/util';
import { actions as previewActions } from '~/story-preview/reducer';
import { actions as analyticsActions } from '~/analytics-middleware/actions';
import { getURL } from '~/server/formatters';
import { SEGMENT_NAMES } from '~/constants';
import getCtaProperties from '~/analytics-middleware/utils/CtaStrings';

import { actions } from './reducer';
import StoryGroups from './components/StoryGroups';

export default connect(
  (state, ownProps) => {
    const { profileId } = ownProps;
    const currentProfile = state.stories.byProfileId[profileId];
    const profileData = state.profileSidebar.profiles.find(
      (p) => p.id === ownProps.profileId
    );

    if (currentProfile && profileData) {
      return {
        loading: currentProfile.loading,
        loadingMore: currentProfile.loadingMore,
        moreToLoad: currentProfile.moreToLoad,
        page: currentProfile.page,
        storyGroups: formatPostLists({
          isManager: profileData.isManager,
          posts: currentProfile.storyPosts,
          scheduleSlotsEnabled: true,
          isStoriesSlot: true,
          profileTimezone: profileData.timezone,
          weekStartsOnMonday: state.user.week_starts_monday,
          weeksToShow: currentProfile.page + 1,
          hasTwentyFourHourTimeFormat: state.user.hasTwentyFourHourTimeFormat,
          profileService: profileData.service,
          orderBy: 'scheduledAt',
        }),
        showStoriesComposer: state.stories.showStoriesComposer,
        showStoryPreview: state.stories.showStoryPreview,
        editMode: state.stories.editMode,
        isDisconnectedProfile: profileData.isDisconnected,
        serviceId: profileData.serviceId,
        userData: state.user,
        hasPushNotifications: profileData.hasPushNotifications,
        translations: state.i18n.translations['story-group-queue'],
      };
    }
    return {};
  },
  (dispatch, ownProps) => ({
    onEmptySlotClick: (storyGroup) => {
      dispatch(
        actions.handleEmptySlotClick({
          emptySlotData: storyGroup,
          profileId: ownProps.profileId,
        })
      );
    },
    onComposerPlaceholderClick: () => {
      dispatch(actions.handleComposerPlaceholderClick());
    },
    onEditClick: (storyGroup) => {
      dispatch(
        actions.handleEditStoryGroupClick({
          storyGroup: storyGroup.post,
          profileId: ownProps.profileId,
        })
      );
    },
    onSetRemindersClick: () => {
      window.location.assign(
        `${getURL.getRemindersURL({
          profileId: ownProps.profileId,
          cta: SEGMENT_NAMES.REMINDERS_STORIES,
          nextUrl: `profile/${ownProps.profileId}/tab/stories`,
        })}`
      );
    },
    handleCloseStoriesComposer: () => {
      dispatch(actions.handleCloseStoriesComposer());
    },
    onPreviewClick: ({ stories, profileId, id, scheduledAt, serviceId }) => {
      const ctaProperties = getCtaProperties(
        SEGMENT_NAMES.STORIES_PREVIEW_QUEUE
      );
      const imageCount = stories.filter(
        (story) => story.type === 'image'
      ).length;
      const videoCount = stories.filter(
        (story) => story.type === 'video'
      ).length;
      const noteCount = stories.filter(
        (story) => story.note && story.note.length > 0
      ).length;
      const metadata = {
        storyGroupId: id,
        channel: 'instagram',
        channelId: profileId,
        channelServiceId: serviceId,
        mediaCount: imageCount + videoCount,
        imageCount,
        videoCount,
        noteCount,
        scheduledAt: JSON.stringify(scheduledAt),
        ...ctaProperties,
      };
      dispatch(analyticsActions.trackEvent('Story Group Previewed', metadata));
      dispatch(
        previewActions.handlePreviewClick({
          stories,
          profileId,
          id,
          scheduledAt,
        })
      );
      dispatch(actions.handlePreviewClick());
    },
    onClosePreviewClick: () => {
      dispatch(actions.handleClosePreviewClick());
    },
    onDeleteConfirmClick: (storyGroup) => {
      dispatch(
        actions.handleDeleteStoryGroup({
          storyGroup,
          profileId: ownProps.profileId,
        })
      );
    },
    onShareNowClick: (storyGroup) => {
      dispatch(
        actions.handleShareNowClick({
          storyGroup: storyGroup.post,
          profileId: ownProps.profileId,
        })
      );
    },
  })
)(StoryGroups);

export { default as reducer, actions, actionTypes } from './reducer';
export { default as middleware } from './middleware';
